<template>
<div class="charts-wrapper">
  <div class="charts-top">
    <div class="normal-wrapper" style="display:grid;grid-template-rows:max-content auto;">
      <div style="display:flex;justify-content:center;">
        <select-ctrl-group :ids="selectedNames" :options="factors" id-prop="name" />
      </div>

      <div style="min-height:0;">
        <e-chart ref="normal-chart" @initialized="onInitialized" @destroy="onDestroy" />
      </div>
    </div>

    <div class="related-wrapper">
      <div class="related-header">
        <el-select
          v-model="x"
          size="small"
          style="width:120px;"
          @change="onFactorIdChanged"
        >
          <el-option
            v-for="factor in factors"
            :key="factor.id"
            :value="factor.id"
            :label="factor.name"
          />
        </el-select>
        <span style="padding:0 .5em;">VS</span>
        <el-select
          v-model="y"
          size="small"
          style="width:120px;"
          @change="onFactorIdChanged"
        >
          <el-option
            v-for="factor in factors"
            :key="factor.id"
            :value="factor.id"
            :label="factor.name"
          />
        </el-select>
      </div>

      <related-chart
        :base-data="relatedData.x"
        :related-data="relatedData.y"
        @dblclick="onRelatedChartDBLClick"
      />
    </div>
  </div>

  <div class="charts-bottom">
    <div class="charts-bottom-header">
      <el-select v-model="selectedFactorId" size="small" @change="onBackgroundFactorIdChanged">
        <el-option
          v-for="factor in backgroundFactors"
          :key="factor.id"
          :value="factor.id"
          :label="factor.name"
        />
      </el-select>

      <el-input v-model="backgroundVal" type="number" size="small" @change="onBackgroundValChanged">
        <template slot="prepend">背景浓度</template>
        <template slot="append">PPB</template>
      </el-input>
    </div>

    <div class="charts-bottom-chart">
      <e-chart ref="background-chart" />
    </div>
  </div>
</div>
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY, TEXT_FONT_FAMILY} from './FactorCharts/chartStyle'
import SelectCtrlGroup from '../SelectCtrlGroup/index'

export default {
  name: 'AuditFactorSelectRelatedChart',
  components: {SelectCtrlGroup},
  props: {
    data: {
      required: true,
      type: Object
    },
    factors: {
      required: true,
      type: Array
    },
    backgroundFactors: {
      required: true,
      type: Array
    },
    backgroundFactorId: {
      required: true
    },
    backgroundValue: {
      required: true,
      type: Number
    },
    unitProp: {
      required: true,
      type: String
    },
    selectedNames: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      x: '',
      y: '',
      relatedData: Object.freeze({
        x: {
          data: []
        },
        y: {
          data: []
        }
      }),
      selectedFactorId: this.backgroundFactorId,
      backgroundVal: this.backgroundValue
    }
  },
  computed: {
    factorMap () {
      return this.factors.reduce((map, factor) => {
        map[factor.id] = factor
        return map
      }, {})
    },
    backgroundFactor () {
      let {selectedFactorId} = this
      return this.backgroundFactors.find(factor => factor.id === selectedFactorId)
    }
  },
  methods: {
    render () {
      this.renderNormalChart()
      this.setXY()
      this.renderRelatedChart()
      this.renderBackgroundFactorChart()
    },
    renderNormalChart () {
      let {data, factors} = this
      let dataList = data.data
      let dataTimes = dataList.map(data => new Date(data.ts).format('YY年MM月DD日HH时'))
      // let ratio = Math.min(50, 50 / dataList.length * 100)
      let chartOpt = {
        title: {
          text: data.name,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        legend: {
          top: 27,
          left: 'center',
          width: '75%',
          type: 'scroll',
          selected: this.getSelected()
        },
        grid: [{
          top: 75,
          right: 40,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: dataTimes,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis: [{
          name: this.factors[0][this.unitProp],
          type: 'value',
          nameGap: 10,
          // nameLocation: 'center',
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          // splitLine: {
          //   show: index === 0
          // },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        }],
        dataZoom: [{
          type: 'inside',
          start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: factors.map(({id, name}) => ({
          id,
          name,
          type: 'line',
          showSymbol: false,
          data: dataList.map(data => data[id])
        }))
      }

      this.$refs['normal-chart'].setOpt(chartOpt)
    },
    setXY () {
      let {factors} = this
      this.x = factors[0].id
      this.y = (factors[1] || factors[0]).id
    },
    renderRelatedChart () {
      let {data, unitProp, factorMap} = this
      let dataList = data.data
      let factors = [this.x, this.y].map(factorId => {
        let factor = factorMap[factorId]
        return {
          id: factor.id,
          name: factor.displayName,
          unit: factor[unitProp]
        }
      })
      this.relatedData = Object.freeze({
        x: this.getValues(factors[0], dataList),
        y: this.getValues(factors[1], dataList)
      })
    },
    getValues (factor, dataList) {
      let factorId = factor.id
      factor.data = dataList.map(data => ({
        dataTime: data.dataTime,
        value: data[factorId],
        flag: data[`${factorId}Flag`]
      }))
      return factor
    },
    onFactorIdChanged () {
      this.renderRelatedChart()
    },
    onRelatedChartDBLClick (chartData) {
      let {data} = this
      let {dataTime} = chartData[4]
      let dataList = data.data
      let index = dataList.findIndex(data => data.dataTime === dataTime)
      let start = Math.max(0, index - 5)
      let end = Math.min(dataList.length, start + 11)
      start = Math.max(0, end - 11)
      this.$emit('dblclick', Object.freeze({
        id: data.id,
        name: data.name,
        dataTime,
        start,
        end,
        dataList: dataList.slice(start, end)
      }))
    },
    onBackgroundFactorIdChanged (backgroundFactorId) {
      this.$emit('update:backgroundFactorId', backgroundFactorId)
      this.$emit('update:backgroundValue', this.backgroundFactor.background)
    },
    onBackgroundValChanged () {
      let value = Number(this.backgroundVal)

      if (Number.isFinite(value)) {
        this.$emit('update:backgroundValue', value)
      }
    },
    renderBackgroundFactorChart () {
      clearTimeout(this.backgroundRenderTimer)

      this.backgroundRenderTimer = setTimeout(() => {
        let {backgroundFactor, backgroundFactorId, backgroundValue, data} = this
        let dataList = data.data
        let dataTimes = dataList.map(data => new Date(data.ts).format('YY年MM月DD日HH时'))
        // let ratio = Math.min(50, 50 / dataList.length * 100)
        let chartOpt = {
          title: {
            text: data.name,
            left: 'center',
            textStyle: {
              fontFamily: TEXT_FONT_FAMILY
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            },
            right: 23
          },
          tooltip: {
            trigger: 'axis',
            appendToBody: true
          },
          legend: {
            top: 27,
            left: 'center',
            width: '75%',
            type: 'scroll'
          },
          grid: [{
            top: 75,
            right: 40,
            bottom: 45,
            left: 30,
            containLabel: true
          }],
          xAxis: [{
            type: 'category',
            data: dataTimes,
            axisLine: {
              show: true,
              lineStyle: AXIS_LINE_STYLE
            },
            axisLabel: {
              ...AXIS_LABEL,
              fontFamily: TEXT_FONT_FAMILY
            },
            axisTick: {
              show: true,
              alignWithLabel: true
            }
          }],
          yAxis: [{
            name: this.backgroundFactors[0][this.unitProp],
            type: 'value',
            nameGap: 10,
            // nameLocation: 'center',
            axisLine: {
              show: true,
              lineStyle: AXIS_LINE_STYLE
            },
            // splitLine: {
            //   show: index === 0
            // },
            axisLabel: {
              ...AXIS_LABEL,
              fontFamily: NUMBER_FONT_FAMILY
            }
          }],
          dataZoom: [{
            type: 'inside',
            start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
            end: 100,
            realtime: true,
            xAxisIndex: 0,
            minSpan: 5
          }, {
            type: 'slider',
            start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
            end: 100,
            realtime: true,
            xAxisIndex: 0,
            minSpan: 5,
            // height: 39,
            bottom: 9,
            left: 'center',
            handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '70%',
            handleStyle: {
              color: '#fff',
              shadowBlur: 4,
              shadowColor: 'rgba(0, 0, 0, 0.15)',
              shadowOffsetX: 2,
              shadowOffsetY: 2
            },
            // dataBackground: {
            //   areaStyle: '#E4F0FF'
            // }
            fillerColor: 'rgba(228, 240, 255, .6)',
            borderColor: '#E4F0FF'
          }],
          series: [{
            id: backgroundFactor.id,
            name: backgroundFactor.name,
            type: 'line',
            data: dataList.map(data => data[backgroundFactorId]),
            showSymbol: false,
            markLine: {
              name: `${backgroundFactor.name}背景浓度`,
              data: [{
                name: `${backgroundFactor.name}背景浓度`,
                yAxis: backgroundValue
              }],
              lineStyle: {
                type: 'solid',
                color: 'red'
              }
            }
          }]
        }

        this.$refs['background-chart'].setOpt(chartOpt)
      }, 0)
    },
    getSelected () {
      let factorIdMap = this.selectedNames.reduce((map, name) => {
        map[name] = true
        return map
      }, {})

      this.factors.reduce((map, {name}) => {
        if (!map[name]) {
          map[name] = false
        }

        return map
      }, factorIdMap)

      return factorIdMap
    },
    onLegendSelectChanged (param) {
      this.selected = Object.freeze(JSON.parse(JSON.stringify(param.selected)))
      this.$emit('update:selectedNames', Object.entries(this.selected).filter(selected => selected[1]).map(selected => selected[0]))
    },
    onInitialized (chartOpj) {
      this.initialized = true
      chartOpj.on('legendselectchanged', this.onLegendSelectChanged)
    },
    onDestroy (chartObj) {
      chartObj.off('legendselectchanged', this.onLegendSelectChanged)
      this.initialized = false
    }
  },
  watch: {
    backgroundFactorId (backgroundFactorId) {
      this.selectedFactorId = backgroundFactorId
      this.renderBackgroundFactorChart()
    },
    backgroundValue (backgroundValue) {
      this.backgroundVal = backgroundValue
      this.renderBackgroundFactorChart()
    },
    selectedNames (selectedNames, old) {
      if (selectedNames !== old) {
        return
      }

      let chartObj = this.$refs['normal-chart']
      let chartOpt = chartObj.getOpt()

      if (!chartOpt) {
        return
      }

      chartObj.setOpt({
        legend: {
          selected: this.getSelected()
        }
      }, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.charts-wrapper {
  display: grid;
  grid-template-rows: 500px 350px;
  grid-row-gap: 10px;
  width: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .charts-top {
    display: grid;
    grid-template-columns: 58% 42%;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .related-wrapper {
      $RELATED-HEADER-HEIGHT: 40px;
      display: grid;
      grid-template-rows: 70px auto;
      padding-top: 30px;

      > * {
        min: {
          width: 0;
          height: 0;
        }
      }

      > .related-header {
        font-size: 22px;
        height: $RELATED-HEADER-HEIGHT;
        line-height: $RELATED-HEADER-HEIGHT;
        text-align: center;

        > * {
          vertical-align: middle;
        }
      }
    }
  }

  > .charts-bottom {
    display: grid;
    grid-template-rows: max-content auto;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .charts-bottom-header {
      display: grid;
      grid-template-columns: auto max-content max-content;
      grid-column-gap: 12px;
      padding: 0 12px;

      &:before {
        content: "";
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/AuditFactorSelectRelatedChart.vue